interface Quantities {
  quantity: number;
  verificationQuantity: number;
  passportQuantity: number;
}

export function adjustOnQuantityChange(
  newQuantity: number,
  verificationQuantity: number,
  passportQuantity: number
): Quantities {
  let adjustedPassport = passportQuantity;
  let adjustedVerification = verificationQuantity;

  if (newQuantity < passportQuantity) {
    adjustedPassport = newQuantity;
  }
  if (adjustedPassport < verificationQuantity) {
    adjustedVerification = adjustedPassport;
  }

  return {
    quantity: newQuantity,
    verificationQuantity: adjustedVerification,
    passportQuantity: adjustedPassport,
  };
}

export function adjustOnVerificationChange(
  quantity: number,
  newVerification: number,
  passportQuantity: number
): Quantities {
  let adjustedQuantity = quantity;
  let adjustedPassport = passportQuantity;

  if (quantity < newVerification) {
    adjustedQuantity = newVerification;
  }
  if (adjustedQuantity < passportQuantity) {
    adjustedPassport = adjustedQuantity;
  }
  if (newVerification > passportQuantity) {
    adjustedPassport = newVerification;
  }

  return {
    quantity: adjustedQuantity,
    verificationQuantity: newVerification,
    passportQuantity: adjustedPassport,
  };
}

export function adjustOnPassportChange(
  quantity: number,
  verificationQuantity: number,
  newPassport: number
): Quantities {
  const adjustedPassport = Math.min(newPassport, quantity);
  const adjustedVerification = Math.min(verificationQuantity, adjustedPassport);

  return {
    quantity,
    verificationQuantity: adjustedVerification,
    passportQuantity: adjustedPassport,
  };
}
